import React from 'react'
import PropTypes from 'prop-types'

const TemplateSelect = ({
  handleTemplateSelection,
  selectionType,
  filteredSettings,
}) => {
  let defaultValue
  switch (selectionType) {
    case 'delete':
      defaultValue = 'Delete Template'
      break
    case 'insert':
      defaultValue = 'Insert Template'
      break
    case 'update':
      defaultValue = 'Update Template'
      break
    default:
      defaultValue = 'Select an Option'
  }
  return (
    <select
      defaultValue={'default'}
      onChange={e => handleTemplateSelection(e, selectionType)}
      disabled={filteredSettings.length === 0}
    >
      <option disabled="true" value="default">
        {defaultValue}
      </option>
      {filteredSettings.map(item => (
        <option key={item.id} value={item.id}>
          {item.template_name}
        </option>
      ))}
    </select>
  )
}

TemplateSelect.propTypes = {
  handleTemplateSelection: PropTypes.func.isRequired,
  selectionType: PropTypes.string.isRequired,
  filteredSettings: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
}

export default TemplateSelect



// WEBPACK FOOTER //
// ./src/components/Messages/TemplateSelect.js